import { NgModule } from '@angular/core';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { NxModule } from '@nrwl/angular';
import { environment } from '../environments/environment';
import { EventsEffects } from './+state/events/events.effects';
import { EventsFacade } from './+state/events/events.facade';
import * as fromEvents from './+state/events/events.reducer';
import { ListingsEffects } from './+state/listings/listings.effects';
import { ListingsFacade } from './+state/listings/listings.facade';
import * as fromListings from './+state/listings/listings.reducer';
import { AppComponent } from './app.component';

import { AppRoutingModule } from './app.routing';
import { AboutComponent } from './components/about/about.component';
import { EventRowComponent } from './components/events/event-row/event-row.component';
import { EventsComponent } from './components/events/events.component';
import { PodcastComponent } from './components/podcast/podcast.component';
import { JobDetailComponent } from './components/job-detail/job-detail.component';
import { JobsComponent } from './components/jobs/jobs.component';
import { LandingComponent } from './components/landing/landing.component';
import { ManageJobComponent } from './components/manage-job/manage-job.component';
import { SponsorsComponent } from './components/sponsors/sponsors.component';
import { ThemeTogglerComponent } from './components/theme-toggler/theme-toggler.component';
import { HttpClientModule } from '@angular/common/http';
import { TranslocoRootModule } from './transloco-root.module';
import { LanguageMenuComponent } from './components/language-menu/language-menu.component';
import { ProfileCardComponent } from './components/profile-card/profile-card.component';
import {MatCardModule} from "@angular/material/card";
import {MatDialogModule} from '@angular/material/dialog';
import {AnnouncementDialogComponent} from './components/announcement-dialog/announcement-dialog.component';
import {MatToolbarModule} from '@angular/material/toolbar';

// ^^^^ IMPORTS ^^^^ //

@NgModule({
  imports: [
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    // AngularFireAnalyticsModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCardModule,
    MatChipsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatSlideToggleModule,
    NxModule.forRoot(),
    StoreModule.forRoot(
        {
          [fromListings.LISTINGS_FEATURE_KEY]: fromListings.reducer,
          [fromEvents.EVENTS_FEATURE_KEY]: fromEvents.reducer,
        },
        {}
    ),
    EffectsModule.forRoot([ListingsEffects, EventsEffects]),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    }),

    AppRoutingModule,
    ThemeTogglerComponent,
    HttpClientModule,
    TranslocoRootModule,
    LanguageMenuComponent,
    MatToolbarModule,
  ],
  bootstrap: [AppComponent],
  declarations: [
    AboutComponent,
    AppComponent,
    AnnouncementDialogComponent,
    JobsComponent,
    LandingComponent,
    JobDetailComponent,
    ManageJobComponent,
    EventsComponent,
    SponsorsComponent,
    EventRowComponent,
    ProfileCardComponent,
    PodcastComponent,
  ],
  providers: [
    ListingsFacade,
    EventsFacade,
    // {
    //   provide: CONFIG,
    //   useValue: {
    //     send_page_view: false,
    //     allow_ad_personalization_signals: false,
    //     anonymize_ip: true,
    //   },
    // },
  ],
})
export class AppModule {}

// ^^^^ CLASS ^^^^ //
